import React from "react";

export interface StickyHeaderContainerProps {
  children: React.ReactNode;
}

export const StickyHeaderContainer = ({ children }: StickyHeaderContainerProps) => {
  return (
    <div
      className="pb-sm border-bottom--grey"
      style={{
        position: "sticky",
        top: "0px",
        backgroundColor: "white",
        borderBottom: "1px solid #CCC",
        paddingTop: "16px",
      }}
    >
      {children}
    </div>
  );
};
